<form nz-form [formGroup]="form" autocomplete="off" role="form">
  <nz-form-item>
    <nz-alert nzType="info" [nzMessage]="'USER_REQUESTS.ALERT' | translate"></nz-alert>
  </nz-form-item>

  <nz-form-item *ngIf="isSaturday">
    <nz-alert nzType="warning" [nzMessage]="'USER_REQUESTS.SATURDAY_TIME_LIMIT_ALERT' | translate"></nz-alert>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzSpan="6" [nzFor]="'language'">
      {{ 'USER_REQUESTS.LANGUAGE' | translate }}
    </nz-form-label>

    <nz-form-control
      [nzValidateStatus]="form.get('language')"
      [nzErrorTip]="'FORM.REQUIRED' | translate"
    >
      <nz-radio-group id="language" formControlName="language" nzButtonStyle="solid">
        <label
          nz-radio-button
          *ngFor="let lang of translationLanguages"
          [nzValue]="lang"
        >
          {{ (lang | uppercase) | translate }}
        </label>
      </nz-radio-group>
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzSpan="6" [nzFor]="'translationMediaType'">
      {{ 'USER_REQUESTS.TRANSLATION_MEDIA_TYPE' | translate }}
    </nz-form-label>

    <nz-form-control
      [nzValidateStatus]="form.get('translationMediaType')"
      [nzErrorTip]="'FORM.REQUIRED' | translate"
    >
      <nz-radio-group
        id="translationMediaType"
        formControlName="translationMediaType"
        nzButtonStyle="solid"
      >
        <label
          nz-radio-button
          *ngFor="let type of translationMediaTypes"
          [nzValue]="type"
          [nzDisabled]="isRequestDisabled(form.get('language').value, type)"
          [title]="('TRANSLATION_SETTINGS.TRANSLATION_MEDIA_TYPES.' + type) | uppercase | translate"
        >
          {{ ('TRANSLATION_SETTINGS.TRANSLATION_MEDIA_TYPES.' + type) | uppercase | translate }}
        </label>
      </nz-radio-group>
    </nz-form-control>
  </nz-form-item>
</form>
